export const bleedOne = {
  src: 'https://alomoves.s3.amazonaws.com/manual_uploads/shared/home/bleed_images/Jan_2022_Update/FIT_FOR_YOUR_LIFESTYLE.jpg',
  alt: 'Woman with weights doing an online barre class using her laptop outside.'
}

export const bleedTwo = {
  src: 'https://alomoves.s3.amazonaws.com/manual_uploads/shared/home/pc-june-2023/half-bleed/world_class_wellness_image.png',
  alt: 'Woman stretching in Gate Pose outside using Alo Moves on iPad.'
}
